import { useTranslation } from 'react-i18next'
import { Loader2 } from 'lucide-react'
import { OrganizationActivityTable } from '@/features/organization-users/components/organization-activity-table'
import { useOrganizationAuditLogs } from '@/features/organization-users/hooks/use-organization-users-api'
import { useSession } from '@/shared/hooks/useSession'

export function OrganizationActivityPage() {
  const { t } = useTranslation('organizationUsers')
  const {
    session: {
      organization: { id: organizationId },
    },
  } = useSession()

  const auditLogsQuery = useOrganizationAuditLogs(organizationId)
  const isLoading = auditLogsQuery.isLoading

  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center p-6">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  const auditLogs = auditLogsQuery.data ?? []

  return (
    <div className="flex flex-1 flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">
          {t('activities.title')}
        </h1>
        <p className="text-muted-foreground">
          {t('activities.pageDescription')}
        </p>
      </div>

      <OrganizationActivityTable data={auditLogs} />
    </div>
  )
}
